import { RolesEnum } from 'app/shared/enums/roles.enum';
import { UserCultureEnum } from 'app/shared/enums/user-culture.enum.model';
import { AgencyDto } from 'app/shared/models/agency.model';
import { UserStatusEnumDTO } from 'app/shared/models/user-info.model';
import { UserCompanyTypeEnum } from '../../enum/user-company-type.enum.model';
import { UserStatusVmEnum } from '../../enum/user-status.enum.model';

import { CustomerFullDTO, CustomerVM } from '../customer/customer.model';
import { AgencyListItemVM } from '../salesNetwork/agency.model';
import { TenantDTO } from 'app/shared/models/tenant.model';

export class UserVM {
  id: number;
  name: string;
  email: string;
  companyName: string;
  companyType: UserCompanyTypeEnum;
  roles: string[];
  status: UserStatusVmEnum;
  agency: AgencyListItemVM;
  customer: CustomerVM;
  mainRole: RolesEnum;
  storeIds: number[];
  isNew?: boolean;
  culture?: UserCultureEnum;
  externalId?: string;
  fullName?: string;
  constructor(init?: Partial<UserVM>) {
    Object.assign(this, init);
    if (!this.roles) this.roles = [];
  }
}

export class UserDTO {
  id: number;
  name: string;
  email: string;
  roles: string[];
  agency: AgencyDto;
  customer: CustomerFullDTO;
  mainRole: RolesEnum;
  storeIds?: number[];
  identityId?: string;
  status?: UserStatusEnumDTO;
  culture?: UserCultureEnum;
  externalId?: string;
  tenant?: TenantDTO;
  constructor(init?: Partial<UserVM>) {
    Object.assign(this, init);
  }
}

export class CreateOrEditUserDTO {
  id: number;
  name: string;
  email: string | undefined;
  externalId: string;
  tenantId: string;
  culture?: UserCultureEnum;
  blockInvitation: boolean;
  constructor(init?: Partial<CreateOrEditUserDTO>) {
    Object.assign(this, init);
  }
}
